import { Ng2StateDeclaration } from "@uirouter/angular";
import { Error502PageComponent } from "./error.502.component";

export const error502StateDeclaration: Ng2StateDeclaration = {
  name: 'error.502',
  url: "/502",
  component: Error502PageComponent
}
